var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styled from '@emotion/styled';
import { space, letterSpacing, lineHeight, fontWeight, borderBottom, borderColor, order, display, flexWrap, alignItems, maxWidth, minWidth, } from 'styled-system';
import dayjs from 'dayjs';
import { Text } from '../../common/components/Text';
// To get the difference in days-hours-minutes-seconds between today and a given date,
// considering the midnight as deadline.
var getTimeLeft = function (endDate) {
    var now = dayjs();
    var deadline = dayjs(endDate);
    if (deadline.isBefore(now)) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    var seconds = dayjs(deadline).diff(now, 'second');
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    return {
        days: days,
        hours: hours % 24,
        minutes: minutes % 60,
        seconds: seconds % 60,
    };
};
var addLeadingZero = function (value) { return (value < 10 ? "0" + value : value); };
/**
 * Date string ending with colon and four digits right after
 * seems to be inexplicable for Safari and IE11
 */
var sanitizeDate = function (date) { return date.replace('+0000', '+00:00'); };
var CountDownContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), lineHeight, display, flexWrap, alignItems, space, order);
CountDownContainer.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    lineHeight: [1, 3],
    order: [3, 1],
};
var CountDownLabel = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), maxWidth, lineHeight);
CountDownLabel.defaultProps = {
    as: 'p',
    maxWidth: '147px',
    mt: 0,
};
var Timer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), fontWeight, letterSpacing, borderBottom, borderColor, space, minWidth);
Timer.defaultProps = {
    fontWeight: 'bold',
    letterSpacing: '2px',
    borderBottom: '2px solid',
    borderColor: 'gray.5',
    ml: '10px',
    minWidth: '110px',
};
var TIMER_INTERVAL = 1000;
var CountDown = /** @class */ (function (_super) {
    __extends(CountDown, _super);
    function CountDown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            timeLeft: getTimeLeft(sanitizeDate(props.endDate)),
            mounted: false,
        };
        _this.tick = _this.tick.bind(_this);
        return _this;
    }
    CountDown.prototype.componentDidMount = function () {
        this.timer = setInterval(this.tick, TIMER_INTERVAL);
        this.setState({ mounted: true });
    };
    CountDown.prototype.componentWillUnmount = function () {
        clearInterval(this.timer);
    };
    CountDown.prototype.tick = function () {
        var _this = this;
        this.setState(function (_, _a) {
            var endDate = _a.endDate;
            return ({
                timeLeft: getTimeLeft(sanitizeDate(endDate)),
            });
        }, function () {
            var deadline = dayjs(sanitizeDate(_this.props.endDate)).endOf('day');
            if (deadline.isBefore(dayjs())) {
                clearInterval(_this.timer);
            }
        });
    };
    CountDown.prototype.render = function () {
        var _a = this.props, label = _a.label, className = _a.className;
        var _b = this.state, _c = _b.timeLeft, days = _c.days, hours = _c.hours, minutes = _c.minutes, seconds = _c.seconds, mounted = _b.mounted;
        return mounted ? (React.createElement(CountDownContainer, { "data-testid": "countdown-container", className: className },
            React.createElement(CountDownLabel, { "data-testid": "count-down-label" }, label),
            React.createElement(Timer, { "data-testid": "count-down-timer" },
                addLeadingZero(days),
                ":",
                addLeadingZero(hours),
                ":",
                addLeadingZero(minutes),
                ":",
                addLeadingZero(seconds)))) : null;
    };
    return CountDown;
}(React.Component));
export default CountDown;
var templateObject_1, templateObject_2, templateObject_3;
